module.exports = __webpack_public_path__ + "static/media/rambu cratejpgWEB.9213d7c4.jpg";